import { localeStore } from '@/shared/i18n/locale-store';
import type { Locale } from '@/shared/i18n/locales';
import { isIsoDate } from './is-iso-date';
import type { IsoDate } from './iso-date';
import { toUtcMs } from './to-utc-ms';

/** "4 nov 2026" / "Nov 4, 2026": a calendar date, never shifted by the time zone. */
export function formatDate(date: IsoDate | undefined | null, locale: Locale = localeStore.read()): string {
  if (!date || !isIsoDate(date)) return '—';
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(toUtcMs(date)));
}
